import { memo as Memo, useMemo, useRef, use, useLayoutEffect } from 'react';
import { useParams } from 'next/navigation';
import { gsap, CSSPlugin } from 'gsap';
import { fetchSectionData } from '@/lib/get-data';

//* Components
import AwardsBlack from './AwardsBlack';
import AwardsWhite from './AwardsWhite';

//* Styles
import AwardsStyle from './style';

const Awards = Memo(({ anime, count, type, active, className }) => {
	//! Refs
	const topRef = useRef();

	//! Params
	const params = useParams();

	const awards = use(fetchSectionData({ name: 'getAwards', lang: params.locale }));

	const items = useMemo(() => {
		let newAwards = awards.slice(0, count ?? awards.length);

		return newAwards.map((item, ind) => {
			return type !== 1 ? (
				<AwardsBlack
					key={ind}
					ind={ind}
					anime={anime}
					{...item}
				/>
			) : (
				<AwardsWhite
					key={ind}
					{...item}
				/>
			);
		});
	}, [awards, anime, count]);

	//! Animation
	const tl = useMemo(() => gsap.timeline({ delay: 0.1 }), []);

	useLayoutEffect(() => {
		const parent = topRef.current;
		if (!parent) return;

		const targets = Array.from(parent.children);
		if (!targets.length) return;

		tl.clear().progress(0);
		tl.to(targets, { opacity: active ? 1 : 0, duration: 0, stagger: 0.1, overwrite: 'auto' });

		return () => tl.clear();
	}, [active, tl]);

	useLayoutEffect(() => {
		return () => tl.kill();
	}, [tl]);

	return (
		<AwardsStyle
			ref={topRef}
			className={`awardsItemWrap ${className || ''} ${type !== 1 ? 'awardsItemBlack' : ''}`}>
			{items}
		</AwardsStyle>
	);
});

export default Awards;
